(function () {
  var SEL = '.hero-image-scroll';

  function init(root) {
    if (!root || root.dataset.hisInit === '1') return;
    root.dataset.hisInit = '1';

    if (!root.classList.contains('hero-image-scroll--animate')) {
      root.classList.add('hero-image-scroll--visible');
      return;
    }

    var prefersReduce =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduce) {
      root.classList.add('hero-image-scroll--visible');
      return;
    }

    var threshold = parseFloat(root.dataset.hisThreshold || '0.2', 10);
    if (Number.isNaN(threshold)) threshold = 0.2;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.remove('hero-image-scroll--pending');
          root.classList.add('hero-image-scroll--visible');
          io.disconnect();
        });
      },
      { threshold: threshold, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(root);
  }

  function scan(doc) {
    (doc || document).querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var sec = ev.target;
    if (!sec || typeof sec.querySelector !== 'function') return;
    scan(sec);
  });
})();
